import AppAPI from '@/api'

/**
 * axiosでの共通エラーハンドリング
 */
export function errorHandler (error) {
  if (error.response) {
    console.log('error.response:')
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data)
    console.log(error.response.status)
    console.log(error.response.headers)
  } else if (error.request) {
    console.log('error.request:')
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request)
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message)
  }
  console.log('error.config:')
  console.log(error.config)

  if (error.response) {
    return {
      error,
      status: error.response.status,
      statusText: error.response.statusText,
      code: error.response.data.code,
      message: error.response.data.message
    }
  } else if (~error.message.indexOf('timeout')) {
    return {
      error,
      status: 408,
      statusText: 'リクエストタイムアウト',
      code: 'Request timeout',
      message: 'リクエストが一定時間以内に完了しませんでした。ネットワークの状態がいい場所で再読み込みしてください。'
    }
  } else if (error.request) {
    return {
      error,
      status: 404,
      statusText: 'リソースが見つかりませんでした',
      code: 'Not found',
      message: 'リソースが見つかりませんでした。'
    }
  } else {
    return {error, status: 'Request error', message: error.message}
  }
}

/**
 * コンポーネントが最新の状態かどうかをチェックする関数
 */
export function isUpdatedComponent (component) {
  const matched = AppAPI.components[component.id]
  if (!matched) return false
  if (component.meta === undefined) return false
  if (component.meta.file !== matched.meta.file) return false
  if (component.meta.name !== matched.meta.name) return false
  if (component.meta.type !== matched.meta.type) return false
  if (component.meta.title !== matched.meta.title) return false
  if (component.meta.description !== matched.meta.description) return false
  return true
}

/**
 * 各コンポーネントのcontentsが最新の状態かどうかを調べ、そうでなければ
 * デフォルト値を追加する
 */
export function migrateComponents (components) {
  return Array.isArray(components) ? components.map(component => {
    const matched = AppAPI.components[component.id]
    if (!matched) return false
    Object.keys(matched.contents).forEach(key => {
      if (component.contents[key] === void 0) {
        if (Array.isArray(component.contents[key])) {
          component.contents[key] = [...matched.contents[key]]
        } else {
          component.contents[key] = {...matched.contents[key]}
        }
      }
    })
    return component
  }) : components
}

export function getFontawesomeIcons () {
  return [
    {value: 'address-card-o'},
    {value: 'book'},
    {value: 'bookmark'},
    {value: 'bookmark-o'},
    {value: 'briefcase'},
    {value: 'building'},
    {value: 'building-o'},
    {value: 'calculator'},
    {value: 'calendar'},
    {value: 'calendar-check-o'},
    {value: 'calendar-minus-o'},
    {value: 'calendar-o'},
    {value: 'calendar-plus-o'},
    {value: 'calendar-times-o'},
    {value: 'camera'},
    {value: 'cloud'},
    {value: 'coffee'},
    {value: 'comment'},
    {value: 'comment-o'},
    {value: 'commenting'},
    {value: 'commenting-o'},
    {value: 'comments'},
    {value: 'comments-o'},
    {value: 'credit-card'},
    {value: 'credit-card-alt'},
    {value: 'cutlery'},
    {value: 'desktop'},
    {value: 'envelope'},
    {value: 'envelope-o'},
    {value: 'envelope-open'},
    {value: 'envelope-open-o'},
    {value: 'exclamation-circle'},
    {value: 'exclamation-triangle'},
    {value: 'eye'},
    {value: 'female'},
    {value: 'gift'},
    {value: 'globe'},
    {value: 'id-card'},
    {value: 'id-card-o'},
    {value: 'info'},
    {value: 'info-circle'},
    {value: 'laptop'},
    {value: 'location-arrow'},
    {value: 'male'},
    {value: 'map'},
    {value: 'map-marker'},
    {value: 'mobile'},
    {value: 'phone'},
    {value: 'question-circle'},
    {value: 'question-circle-o'},
    {value: 'road'},
    {value: 'street-view'},
    {value: 'suitcase'},
    {value: 'tachometer'},
    {value: 'tag'},
    {value: 'tags'},
    {value: 'television'},
    {value: 'thumbs-up'},
    {value: 'thumbs-o-up'},
    {value: 'umbrella'},
    {value: 'user'},
    {value: 'user-circle'},
    {value: 'user-circle-o'},
    {value: 'user-o'},
    {value: 'users'},
    {value: 'ambulance'},
    {value: 'bicycle'},
    {value: 'bus'},
    {value: 'car'},
    {value: 'motorcycle'},
    {value: 'plane'},
    {value: 'subway'},
    {value: 'taxi'},
    {value: 'train'},
    {value: 'truck'},
    {value: 'wheelchair'},
    {value: 'wheelchair-alt'},
    {value: 'area-chart'},
    {value: 'bar-chart'},
    {value: 'line-chart'},
    {value: 'pie-chart'},
    {value: 'yen'},
    {value: 'hand-o-up'},
    {value: 'hand-o-left'},
    {value: 'hand-o-right'},
    {value: 'hand-o-down'},
    {value: 'facebook'},
    {value: 'facebook-official'},
    {value: 'facebook-square'},
    {value: 'google'},
    {value: 'google-plus'},
    {value: 'google-plus-official'},
    {value: 'wordpress'},
    {value: 'youtube'},
    {value: 'youtube-play'}
    // // {value: 'accessible-icon'},
    // {value: 'address-book'},
    // {value: 'address-card'},
    // {value: 'ambulance'},
    // // {value: 'app-store'},
    // {value: 'apple'},
    // {value: 'archive'},
    // {value: 'at'},
    // {value: 'barcode'},
    // {value: 'bicycle'},
    // {value: 'blind'},
    // {value: 'bluetooth-b'},
    // {value: 'bolt'},
    // {value: 'book'},
    // {value: 'bookmark'},
    // {value: 'briefcase'},
    // {value: 'building'},
    // {value: 'bus'},
    // {value: 'calculator'},
    // {value: 'calendar'},
    // // {value: 'calendar-alt'},
    // // {value: 'calendar-check'},
    // // {value: 'calendar-minus'},
    // // {value: 'calendar-plus'},
    // // {value: 'calendar-times'},
    // {value: 'camera'},
    // {value: 'camera-retro'},
    // {value: 'car'},
    // // {value: 'chart-area'},
    // // {value: 'chart-bar'},
    // // {value: 'chart-line'},
    // // {value: 'chart-pie'},
    // {value: 'check'},
    // {value: 'child'},
    // {value: 'clipboard'},
    // // {value: 'clock'},
    // {value: 'clone'},
    // {value: 'cloud'},
    // {value: 'coffee'},
    // {value: 'cog'},
    // {value: 'comment'},
    // // {value: 'comment-alt'},
    // {value: 'comments'},
    // {value: 'copy'},
    // {value: 'credit-card'},
    // {value: 'desktop'},
    // {value: 'edit'},
    // {value: 'envelope'},
    // {value: 'envelope-open'},
    // {value: 'exclamation'},
    // // {value: 'exclamation-cicle'},
    // {value: 'exclamation-triangle'},
    // // {value: 'facebook-messenger'},
    // {value: 'facebook-square'},
    // {value: 'female'},
    // // {value: 'flight-jet'},
    // {value: 'file'},
    // {value: 'gift'},
    // {value: 'globe'},
    // {value: 'google'},
    // {value: 'google-plus'},
    // // {value: 'hand-paper'},
    // // {value: 'hand-point-right'},
    // // {value: 'handshake'},
    // {value: 'heart'},
    // {value: 'home'},
    // {value: 'id-badge'},
    // {value: 'id-card'},
    // {value: 'image'},
    // // {value: 'images'},
    // {value: 'info-circle'},
    // {value: 'instagram'},
    // {value: 'key'},
    // {value: 'life-ring'},
    // // {value: 'line'},
    // {value: 'link'},
    // {value: 'list'},
    // {value: 'list-alt'},
    // {value: 'list-ol'},
    // {value: 'list-ul'},
    // {value: 'location-arrow'},
    // {value: 'lock'},
    // // {value: 'lock-open'},
    // {value: 'male'},
    // {value: 'map'},
    // // {value: 'map-marker'},
    // // {value: 'map-marker-alt'},
    // {value: 'map-pin'},
    // {value: 'microphone'},
    // {value: 'microphone-slash'},
    // {value: 'mobile'},
    // // {value: 'mobile-alt'},
    // {value: 'motorcycle'},
    // {value: 'paperclip'},
    // {value: 'phone'},
    // {value: 'plane'},
    // {value: 'print'},
    // {value: 'question'},
    // // {value: 'question-cicle'},
    // {value: 'search'},
    // {value: 'search-minus'},
    // {value: 'search-plus'},
    // {value: 'server'},
    // // {value: 'shield-alt'},
    // {value: 'star'},
    // {value: 'sticky-note'},
    // {value: 'street-view'},
    // {value: 'subway'},
    // {value: 'sync'},
    // // {value: 'sync-alt'},
    // // {value: 'tablet-alt'},
    // // {value: 'tachometer-alt'},
    // {value: 'tag'},
    // {value: 'tags'},
    // {value: 'tasks'},
    // {value: 'taxi'},
    // {value: 'truck'},
    // {value: 'user'},
    // // {value: 'user-cicle'},
    // {value: 'users'},
    // // {value: 'utensil-spoon'},
    // // {value: 'utensils'},
    // // {value: 'video'},
    // {value: 'wheelchair'},
    // {value: 'windows'},
    // {value: 'wordpress'},
    // // {value: 'yen-sign'},
    // {value: 'youtube'},
    // {value: 'youtube-square'}
  ]
}

export default {
  errorHandler,
  isUpdatedComponent,
  migrateComponents,
  getFontawesomeIcons
}



// WEBPACK FOOTER //
// ./src/helpers/index.js